import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent, DxPopupComponent } from 'devextreme-angular';
import { DxoExportComponent, DxoPagingComponent } from 'devextreme-angular/ui/nested';
import { BehaviorSubject } from 'rxjs';
import { ImportResult } from 'src/app/models/import-result';

@Component({
  selector: 'app-popup-import-distributori-result',
  templateUrl: './popup-import-distributori-result.component.html',
  styleUrls: ['./popup-import-distributori-result.component.scss'],
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxoPagingComponent,
    DxoExportComponent
  ],
  standalone: true
})
export class PopupImportDistributoriResultComponent implements OnInit, OnChanges {
  @Input() popupVisibleObs: BehaviorSubject<boolean>;
  @Input() importResult: ImportResult;
  @Input() popupTitle: string;
  popupVisible = false;
  listErrori : any [];
  @ViewChild('gridMessaggiErrore', { static: false }) dataGridMessaggiErrore: DxDataGridComponent;

  ngOnInit(): void {
    this.popupVisibleObs.subscribe(vis => {
      this.popupVisible = vis;
      if (vis) {
        
        this.dataGridMessaggiErrore.instance.refresh();
        this.dataGridMessaggiErrore.instance.pageIndex(0);
      }
    });
  }

  ngOnChanges() {
    //CONTROLLO CHE L'AZIENDA NON SIA NULL
    if (this.importResult != undefined) {
      this.listErrori = this.importResult.listaErrori.map((item) => {
        const riga : any = new Object();
        riga.Messaggio = item;
        return riga;
      }
      );
      
    }
  }

  closedPopup() {
    this.popupVisibleObs.next(false);
  }

}
